<template>
	<section class="container" id="loginSection">
        <div class="row" id="logoArea">
			 <label class="loginLogoCss">HR融担平台</label>
        </div>
        <div class="row">
            <div class=" col-sm-offset-5" id="loginPanel">
              	<el-popover ref="verifyImg" placement="bottom-end" width="170" trigger="focus" @show="changeImg">
              		<img :src="verifyImgUrl"  style="width:150px"/>
              	</el-popover>
              	<el-form ref="form" :model="form"  label-position='top' label-width="100px" >
	              	<el-form-item  prop="username" :error="error.username" >
					    <el-input v-model="form.username" placeholder="请输入帐号/姓名/手机号" :maxlength="32" style="outline:none;outline:medium;">
							<template slot="prepend"><img src="../../../static/img/login_icon_01.png" alt="" style="width:18px;height:18px;"></template>
						</el-input>
					</el-form-item>
					<el-form-item  prop="password" ref="password" :error="error.password" >
					    <el-input type="password" v-model="form.password" placeholder="请输入密码" :maxlength="32">
							<template slot="prepend"><img src="../../../static/img/login_icon_02.png" alt=""style="width:18px;height:18px;"></template>
						</el-input>
					</el-form-item>
					<el-form-item  prop="verify_code" ref="verify_code" :error="error.verify_code" >
					    <el-input v-model="form.verify_code" placeholder="请输入验证码" :maxlength="5" v-popover:verifyImg>
							<template slot="prepend"><img src="../../../static/img/login_icon_03.png" alt="" style="width:18px;height:18px;"></template>
						</el-input>
					</el-form-item>
					<el-form-item label-width='80px'>
					    <el-switch active-text="" active-value="yes" inactive-text="" inactive-value="no" v-model="form.remember"></el-switch>
					</el-form-item>
              	</el-form>
              	<div class="row submitArea">
              		<div class="col-sm-12">
						<el-button class="btn-block" type="primary" @click="loginSubmit">登录</el-button>
					</div>
				</div>
            </div>
        </div>
        <footer class="row loginFooter">
            <p class="text-center loginfFooterText">版权所有：福州索弗企业管理咨询有限公司</p>
        </footer>
    </section>
</template>

<script>
import $ from 'jquery'
import _this from '../../lib/common/user'

let _p = window.xwCommon,
	methods = {
	loginSubmit(e){
		this.$refs['form'].validate((valid) => {
          	if (valid) {
				  this.$bus.emit("loading",true)
				  console.log(this.form)
            	_this.userSignIn(this.form,this).then((json) => {
					// console.log(json)
					this.$bus.emit("loading",false)
					this.$bus.emit("loginOK",true)
               /*      this.$bus.emit('push-router',{name:"/"})*/
					
            	},(json) => {
					console.log(json)
            		this.$bus.emit("loading",false)
            		let status = parseInt(json.status)
            		switch(status) {
						case 1002:
							json.data.forEach((desc)=>{
			                  	//console.log(desc)
			                  	this.$set(this.error, desc.name, desc.error)
			                })
			                break
						case 2000:
							this.$set(this.error, "verify_code", "验证码错误！")
							this.$alert(json.msg,"用户登录")
							break
						case 2001:
							this.$alert(json.msg,"用户登录")
							break
						default:
							_p.promiseErrorChecker(this, json, "用户登录")
		  					break
					}
					this.form.verify_code = ""
            	})
          	} else {
	            //console.log('error submit!!');
	            return false;
          	}
        });
	},
	changeImg(e){
		this.verifyImgUrl = _this.getVerifyImg()
	},
	getVerifyImg(){
		return _p.getApiUrl("login/verifyCode",{"_t":$.now()})
	}
}

export default {
  	name: 'login', methods,
  	data(){
  		return {
  			news: "生命之灯因热情而点燃，生命之舟因拼搏而前行！",
  			form: {
  				username: "",
  				password: "",
  				verify_code: "",
  				remember: "no"
  			},
  			rules: {
  				username:[
  					{ required: true, message: '请输入帐号', trigger: 'blur' },
  					{ min: 2, max: 32, message: '帐号格式错误', trigger: 'blur' }
  				],
  				password:[
  					{ required: true, message: '请输入密码', trigger: 'blur' },
  					{ min: 6, max: 32, message: '密码格式错误', trigger: 'blur' }
  				],
  				verify_code:[
  					{ required: true, message: '请输入验证码', trigger: 'blur' },
  					{ min: 5 , length: 5 , message: '验证码格式错误', trigger: 'blur' }
  				]
  			},
  			error:{username: "",password: "",verify_code: "",remember:""},
  			verifyImgUrl:"",
  			isLoginBack:false,
  		}
  	},
  	mounted(){
  		this.isLoginBack=(window.location.pathname=="/login")
  	    $("title").html("HR融担平台")
  		_p.setStoredProp("isLoginBack",{"isLoginBack":this.isLoginBack})
		$("#loginSection").css("background-image","url(static/img/login_img_01.png)")
		$("#logoArea span.logo").css("background-image","url(static/img/login_logo.png)")
		$('#loginSection').css('height',window.innerHeight+'px')
  	}
};


</script>

<style scoped>

	#loginSection {	
		/* margin: 60px auto; */
		width: 100%;
		/* background-color: red; */

	}

	#logoArea {
		height:90px;
        background: rgba(248,243,243,0.16);
		/* margin-top: 100px; */
		margin-bottom: 170px;
	}

	#logoArea p {
		margin-top: 100px;
		line-height: 20px;
	}

	#loginPanel {
	    width: 350px;
		border-radius: 5px;
		padding: 20px;
		background: rgba(248,243,243,0.16);
		/* opacity: 0.5; */
		border:1px solid #ddd;
		margin-bottom: 50px;
	    z-index: 2000;
	}

	#loginPanel .singleHead {
		margin: 0 -15px 20px;
		font-weight: bold;
		text-align: center;
		line-height: 68px;
		font-size: 24px;
		color:#666;
		border-bottom: 1px solid #f1f1f1;
	}
    #loginPanel img{
		height: 10px;
	}
	#loginPanel .checkbox {
		position: static;
		padding-top: 0;
	}
   .submitArea{
	   padding-top: 20px;
   }
	#loginPanel .submitArea {
		margin: 5px -15px;
		border-top: 1px solid rgba(173,179,185,0.46);	
		/* padding: 15px; */
	}

	#inputVerifyImg img {
		width:100%;
		cursor:pointer;
	}
	.loginFooter{
		height: 90px;
        background: rgba(248,243,243,0.16);
		position: fixed;
        bottom: 0;
	    width: 100%;
		
	}
	.loginfFooterText{
		line-height: 90px;
		font-size: 20px;
		color: #ffffff;
	}
	#logoArea>span{
		margin: 25px 0 0 350px;
		height: 40px;
		background-size: 100% 100%;
		width: 287px;
		display: inline-block;
	}
	.inputIoc{
	   width: 20px;
	   height: 40px;
	   background-color: red;
	}
	.loginLogoCss{
       color:#fff;font-size:30px;padding: 20px 85px;  margin-left: 180px;
	}
</style>


// WEBPACK FOOTER //
// login.vue?7f86744a